// Sticky "On this page" outline rail (note-layout mockup B): sections + subheadings, active-position
// highlight, click-to-jump. ≤640px the rail is CSS-hidden and the toggle button opens the same list
// as a popover.

import { useState } from 'react';
import type { OutlineEntry } from './NoteSections';

export function NoteOutline({ entries, activeId, onJump }: {
  entries: OutlineEntry[];
  activeId: string | null;
  onJump: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  if (entries.length === 0) return null;
  return (
    <nav className="nd-rail" aria-label="On this page">
      <button type="button" className="nd-rail-toggle" onClick={() => setOpen(o => !o)}>
        On this page
      </button>
      <div className={`nd-rail-list${open ? ' is-open' : ''}`}>
        <div className="nd-rail-label">ON THIS PAGE</div>
        {entries.map((e) => (
          <button key={e.id} type="button"
            className={`nd-ri${e.sub ? ' sub' : ''}${activeId === e.id ? ' is-active' : ''}`}
            onClick={() => { setOpen(false); onJump(e.id); }}>
            {e.label}
          </button>
        ))}
      </div>
    </nav>
  );
}
